Postlogin.Lesson = (function (my) {
    my.Ordering = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container = null;
        const numberOfOptions = Object.keys(me.options).length;
        let numberMatched = 0;
        const correctOrder = [];
        let lastPlaceholderPosition = null;

        const sortableOptions = {
            fixed: '> .correct',
            items: 'li:not(.ui-state-disabled)',
            placeholder: 'ui-state-highlight',
            update() {
                Postlogin.Lesson.playSoundEffect('place');
            },

            start() {
                Postlogin.Lesson.playSoundEffect('pick_up');
            },

            stop(event, ui) {
                $(ui.item).removeClass('grabbing');
            },

            change() {
                const placeholder = $(container).find('.ui-sortable-placeholder');

                if (lastPlaceholderPosition !== $(placeholder).position().top) {
                    Postlogin.Lesson.playSoundEffect('click');
                    lastPlaceholderPosition = $(placeholder).position().top;
                }
            },
        };

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            const positions = $('<ul></ul>').addClass('positions');
            const sortable = $('<ul></ul>').addClass('sortable');
            let index = 1;
            let numberUnderFourCharacters = 0;

            $.each(me.options, (i, option) => {
                correctOrder[index - 1] = option.activity_option_id;

                // add position
                const position = $(`<li class="position-${index}"><span class="cartoony">${index} :</span></li>`);
                positions.append(position);

                const item = $(`<li class="ui-state-default item option-${index}"></li>`);
                item.attr('data-option-id', option.activity_option_id);
                item.attr('data-position', i);

                const wrapper = $('<div></div>').addClass('wrapper');
                if (option.answer_image) {
                    item.addClass('has-image');
                    wrapper.css('backgroundImage', `url(${option.answer_image})`);
                } else {
                    item.addClass('text-only');
                }

                if (option.answer_audio) {
                    item.addClass('has-audio');
                    item.attr('data-audio', option.answer_audio);
                }

                let optionText;
                if (option.answer) {
                    if (option.answer_image) {
                        optionText = $(`<div class="option-text"><span>${option.answer}</span></div>`);
                    } else {
                        optionText = $(`<div class="option-text"><span>${option.answer}</span></div>`);
                    }

                    if (option.answer.length <= 4) {
                        optionText.addClass('under-four-characters');
                        numberUnderFourCharacters++;
                    }
                    wrapper.append(optionText);
                }

                item.on('mouseup', function (e) {
                    $(this).removeClass('grabbing');
                    e.originalEvent.preventDefault();
                });

                item.append(wrapper);

                if (numberUnderFourCharacters === numberOfOptions) {
                    sortable.addClass('all-under-four-characters');
                }

                // randomize order of items (if shuffled == 1)
                if (+me.activity_data.shuffled === 1 && Math.floor(Math.random() * 2)) {
                    sortable.append(item);
                } else {
                    sortable.prepend(item);
                }
                index++;
            });

            segmentContainer.append(positions);
            segmentContainer.append(sortable);
            segmentContainer.append(
                '<div class="check-container"><button class="check-order"><i class="fa fa-check-circle" aria-hidden="true"></i> Check Answer</button></div>',
            );

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);

            $(container).on('click', '.check-order', () => {
                me.checkOrder();
            });

            me.totallyShuffle();

            $(container).find('.sortable').fixedsortable(sortableOptions);
        };

        me.totallyShuffle = function () {
            $(container).find('.sortable > li').shuffle();

            // Initially... some items might be in the correct order...
            // Keep shuffling the order until NO items are in the correct spot
            let totallyShuffled = false;
            while (!totallyShuffled) {
                let shuffled = true;
                $(container)
                    .find('.sortable > li')
                    .each((index, item) => {
                        const optionId = $(item).attr('data-option-id');
                        const correctId = correctOrder[index];
                        if (correctId === +optionId) {
                            shuffled = false;
                        }
                    });
                if (!shuffled) {
                    $(container).find('.sortable > li').shuffle();
                } else {
                    totallyShuffled = true;
                }
            }
        };

        me.checkOrder = function () {
            let update = false;
            numberMatched = 0;

            $(container)
                .find('.sortable > li')
                .each((index, item) => {
                    const optionId = $(item).attr('data-option-id');
                    const correctId = correctOrder[index];
                    if (correctId === +optionId) {
                        $(item).addClass('correct');
                        numberMatched++;
                        update = true;
                    } else {
                        $(item).addClass('incorrect animated shake');
                    }
                });

            if (update) {
                $(container).find('.sortable').fixedsortable('destroy');
                $(container).find('.sortable').fixedsortable(sortableOptions);
            }

            if (numberMatched === numberOfOptions) {
                setTimeout(() => {
                    Postlogin.Lesson.playSoundEffect('correct');
                    Postlogin.Lesson.Popup.showCompletionModal(me);
                }, 750);
            } else {
                Postlogin.Lesson.playSoundEffect('incorrect');
                setTimeout(() => {
                    $(container).find('.sortable > li').removeClass('animated shake incorrect adjacent');
                }, 2000);
            }
        };

        me.replay = function (forceShowHelp = false) {
            numberMatched = 0;

            $(container).find('.sortable > li').removeClass('animated shake correct incorrect adjacent');

            me.totallyShuffle();

            $(container).find('.sortable').fixedsortable('destroy');
            $(container).find('.sortable').fixedsortable(sortableOptions);

            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    if (me.completed && !me.last) {
                        Postlogin.Lesson.showNextButton();
                    }
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
